"use client";

import { App } from "antd";

import AntDesignProvider from "@/providers/antDesign-provider";

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
      <AntDesignProvider>
        <App>{children}</App>
      </AntDesignProvider>
  );
}
